import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/parking_locks',
  component: Management,
  redirect: '/parking_locks/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/parking_locks/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listParkingLocks
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/parking_locks/ListTable'),
          meta: {
            auth: Auth.listParkingLocks,
            tabName: 'all'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/parking_locks/DetailLayout'),
      meta: {
        auth: Auth.showParkingLock
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/parking_locks/details/Detail'),
          meta: {
            auth: Auth.showParkingLock
          }
        }
      ]
    }
  ]
}
